import React from "react";

type Props = {
    greeted: () => boolean;
};

type State = {
    t1: string;
    t2: string;
    t3: string;
    t4: string;
    t5: string;
};

class Greet extends React.Component<Props, State> {
    state = { t1: "", t2: "", t3: "", t4: "", t5: "" };
    t1 = "";
    t2 = "";
    t3 = "";
    t4 = "";
    t5 = "";

    constructor(props: Props) {
        super(props);
        this.t1 =
            "Hey! I'm Arjun, a final-year Computer Science and Mathematics student at ";
        this.t2 = "BITS Pilani";
        this.t3 =
            ". I'm interested in Systems and Software Development. I'm most accessible through ";
        this.t4 = "email";
        this.t5 = ". Feel free to get in touch!";
    }

    render() {
        return (
            <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-10">
                    <div className="Greet" id="greet">
                        <h1>
                            {this.state.t1}
                            <a
                                href="https://bits-pilani.ac.in/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                {this.state.t2}
                            </a>
                            {this.state.t3}
                            <a
                                href="mailto:kumarmallikarjuna1@gmail.com"
                                target="_blank"
                                rel="noreferrer"
                            >
                                {this.state.t4}
                            </a>
                            {this.state.t5}
                            <span></span>
                        </h1>
                    </div>
                </div>
            </div>
        );
    }

    componentDidMount() {
        if (this.props.greeted()) {
            this.setState(state => ({
                t1: this.t1,
                t2: this.t2,
                t3: this.t3,
                t4: this.t4,
                t5: this.t5
            }));

            return;
        }

        const l1 = this.t1.length;
        const l2 = l1 + this.t2.length;
        const l3 = l2 + this.t3.length;
        const l4 = l3 + this.t4.length;
        const l5 = l4 + this.t5.length;

        let update_text = (i: number) => {
            if (i < l1) {
                this.setState(state => ({
                    t1: state.t1 + this.t1[i]
                }));

                setTimeout(() => {
                    update_text(i + 1);
                }, 25);
            } else if (i < l2) {
                this.setState(state => ({
                    t2: state.t2 + this.t2[i - l1]
                }));

                setTimeout(() => {
                    update_text(i + 1);
                }, 25);
            } else if (i < l3) {
                this.setState(state => ({
                    t3: state.t3 + this.t3[i - l2]
                }));

                setTimeout(() => {
                    update_text(i + 1);
                }, 25);
            } else if (i < l4) {
                this.setState(state => ({
                    t4: state.t4 + this.t4[i - l3]
                }));

                setTimeout(() => {
                    update_text(i + 1);
                }, 25);
            } else if (i < l5) {
                this.setState(state => ({
                    t5: state.t5 + this.t5[i - l4]
                }));

                setTimeout(() => {
                    update_text(i + 1);
                }, 25);
            }
        };

        update_text(0);
    }
}

export default Greet;
